import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Component } from 'react';
import { _argus_decode } from '@ies/argus-decode';
import { getLocalText } from '@/utilities/language';
// import env from '@/env';

var host = "".concat(window.location.origin, "/open_api/v1/api/upload/");
// const { href } = window.location;
// if (href.includes('preview')) {
//   host = env.cdn.uploadFile;
// } else {
//   host = `${window.location.origin}/open_api/v1/api/upload/`;
// }
var Upload = /*#__PURE__*/function (_Component) {
  _inherits(Upload, _Component);
  function Upload() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Upload);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Upload)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validator", function (rules, answer, callback) {
      var required = _this.props.question.required;
      if (required && answer.list.length === 0) {
        callback(getLocalText('SingleChoice.Selected')); // '请填写答案');
        return;
      }
      if (answer.list.some(function (el) {
        return !el;
      })) {
        callback('uploading');
        return;
      }
      callback();
    });
    return _this;
  }
  _createClass(Upload, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (window.isReport) {
        var _nowAnswer$list;
        var nextQ = this.props.question;
        var nowAnswer = this.props.answers[nextQ.id];
        var prevAnswer = prevProps.answers[nextQ.id];
        if (((_nowAnswer$list = nowAnswer.list) === null || _nowAnswer$list === void 0 ? void 0 : _nowAnswer$list[0]) !== (prevAnswer === null || prevAnswer === void 0 ? void 0 : prevAnswer[0])) {
          this.getFileListChange({
            fileList: nowAnswer.list
          });
        }
      }
    }
  }, {
    key: "getFileListChange",
    value: function getFileListChange(_ref) {
      var fileList = _ref.fileList,
        _ref$text = _ref.text,
        text = _ref$text === void 0 ? '' : _ref$text;
      return {
        text: text,
        list: fileList,
        type: 'upload'
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        question = _this$props.question,
        answer = _this$props.answer;
      var _question$custom = question.custom,
        max = _question$custom.max,
        _question$custom$with = _question$custom.withText,
        withText = _question$custom$with === void 0 ? false : _question$custom$with,
        _question$custom$plac = _question$custom.placeholder,
        placeholder = _question$custom$plac === void 0 ? '' : _question$custom$plac,
        _question$custom$acce = _question$custom.accept,
        accept = _question$custom$acce === void 0 ? ['image/*', 'video/*', 'audio/*'] : _question$custom$acce;
      var _this$props$form = this.props.form,
        getFieldProps = _this$props$form.getFieldProps,
        getFieldError = _this$props$form.getFieldError;
      var id = question.id || 'unknown-form-item';
      var _getFieldProps = getFieldProps(id, {
          initialValue: answer,
          rules: [{
            required: true,
            validator: this.validator
          }]
        }),
        _onChange = _getFieldProps.onChange,
        formAnswer = _getFieldProps.value;
      var error = getFieldError(id);
      if (error && error.length > 0) error = error.join(',');else error = null;
      var params = {
        withText: withText,
        placeholder: placeholder,
        max: max,
        host: host,
        error: error,
        accept: accept.length === 0 ? ['image/*', 'video/*', 'audio/*'] : accept,
        formAnswer: formAnswer,
        onChange: function onChange(val) {
          return _onChange(_this2.getFileListChange(val));
        }
      };
      return this.props.children(params);
    }
  }]);
  return Upload;
}(Component);
_defineProperty(Upload, "defaultProps", {
  answer: {
    list: [],
    type: 'upload'
  }
});
export { Upload as default };